import svg from './row-svg/champagne.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ChampagneIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default ChampagneIcon;
